import React from "react";
import styles from "./Style.module.css";
import { ArrowBackIos, Edit } from "@mui/icons-material";
import history from "../../../libs/history.utils";
import useHealthTipsDetail from "./HealthTipsDetail.hook";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import { ButtonBase, CardMedia, Typography, Box } from "@mui/material";
import StatusPill from "../../../components/Status/StatusPill.component";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import { ArrowOutlineButton } from "../../../components/Buttons/PrimaryButton";
import duplicate from "../../../assets/CRMAssets/ic_duplicate_orange@2x.png";
import useRoles from "../../../hooks/RoleHook";
import Constants from "../../../config/constants";
function HealthTipsDetail() {
  const { data, handleEdit, handleCopy } = useHealthTipsDetail({});
  const {canDelete, canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.HEALTH_TIPS_MASTER);
  return (
    <div>
      <div className={styles.outerFlex1}>
        <div className={styles.iconButton}>
          <div className={styles.arrowWrap}>
            <ButtonBase onClick={() => history.goBack()}>
              <ArrowBackIos fontSize={"small"} />{" "}
            </ButtonBase>
            <Typography variant={"title1"}>Health Tip Detail</Typography>
          </div>
          <div className={styles.buttonRow}>
            {/* <ArrowOutlineButton
              onClick={handleCopy}
              icon={
                <img
                  src={duplicate}
                  alt="duplicate"
                  className={styles.duplicate}
                />
              }
            >
              DUPLICATE
            </ArrowOutlineButton> */}
            {canUpdate &&<ArrowOutlineButton
              onClick={handleEdit}
              icon={<Edit fontSize="normal" />}
            >
              Edit
            </ArrowOutlineButton>}
          </div>
        </div>
        <ShadowBox className={styles.Container}>
          <img
            src={data?.image}
            className={styles?.imageWrap}
            crossOrigin="anonymous"
          />

          {/* Content Section */}
          <Box sx={{ flexGrow: 1, ml: 1 }}>
            <div>
              <Typography variant="h5" component="div" fontWeight="bold">
                {capitalizeFirstLetter(data?.title)}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {capitalizeFirstLetter(data?.short_brief)}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {data?.startDateText}
              </Typography>
              {/* <Typography variant="body1" color="text.secondary">
                Priority: <strong>{data?.priority}</strong>
              </Typography> */}
              <Typography variant="body1" color="text.secondary">
                Client: <strong>{data?.client?.name?.toUpperCase()}</strong>
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Associated Program:{" "}
                <strong>
                  {capitalizeFirstLetter(
                    data?.programs?.map((val) => val?.name)?.join(" , ")
                  )}
                </strong>
              </Typography>
            </div>
          </Box>

          <Box>
            <StatusPill status={data?.status} color={data?.status} />
          </Box>
        </ShadowBox>
        <ShadowBox className={styles.Container21}>
          <div className={styles.headingRow}>
            <Typography variant="h5" component="div" fontWeight="bold">
              Description
            </Typography>
            {data?.link && (
            <Typography variant={"subtitle1"} className={styles.link}>
              <a
                href={data?.link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.urlColor}
              >
                View External Link
              </a>
            </Typography>
            )}
          </div>
          <Typography
            variant="body1"
            color={"text.secondary"}
            sx={{ marginTop: "-20px" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: data?.description,
              }}
            />
          </Typography>
        </ShadowBox>
      </div>
    </div>
  );
}

export default HealthTipsDetail;
